import React from 'react';

import type { LaneMode } from '../../../apis/lanePlanner';

export const MODE_ICON_PATH: Record<LaneMode | 'multi', string> = {
  air: 'M2 14l8-3V4.5A1.5 1.5 0 0 1 11.5 3 1.5 1.5 0 0 1 13 4.5V11l8 3v2.5l-8-2v4l2 1.5V22l-3.5-1L8 22v-2l2-1.5v-4l-8 2Z',
  ocean:
    'M4 11V7h4V5h8v2h4v4l-2 6H6l-2-6Zm-2 8c1.5 1 3 1 4.5 0s3-1 4.5 0 3 1 4.5 0 3-1 4.5 0',
  road: 'M2 7h11v9H2Zm11 3h5l3 3v3h-8Zm-7 8a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Zm11 0a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z',
  multi: 'M7 4 3 8l4 4M3 8h13M17 12l4 4-4 4m4-4H8',
};

/** The mode's glyph, in the current text colour. */
const ModeIcon: React.FC<{ mode: LaneMode | 'multi'; size?: number }> = ({
  mode,
  size = 14,
}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' aria-hidden>
    <path
      d={MODE_ICON_PATH[mode]}
      stroke='currentColor'
      strokeWidth='1.7'
      fill='none'
    />
  </svg>
);

export default ModeIcon;
